import { QuestionModel } from "../QuestionModel";
import { VariableModel } from "../VariableModel";
import { ValidationResultModel } from "../ValidationResultModel";

/** Keys that may carry validation errors for a choice list item (variable, question, grid parent). */
export function getChoiceValidationErrorKeys(
    question?: QuestionModel | null,
    variable?: VariableModel | null,
): string[] {
    const keys = new Set<string>();
    if (variable?.name) {
        keys.add(variable.name);
    }
    if (question?.name) {
        keys.add(question.name);
    }
    if (question?.parent?.name) {
        keys.add(question.parent.name);
    }
    return Array.from(keys);
}

export function hasChoiceValidationError(
    errorsByVariableName: ValidationResultModel["errorsByVariableName"] | null | undefined,
    question?: QuestionModel | null,
    variable?: VariableModel | null,
): boolean {
    if (!errorsByVariableName) {
        return false;
    }
    return getChoiceValidationErrorKeys(question, variable).some(
        (key) => (errorsByVariableName[key]?.length ?? 0) > 0,
    );
}
